import { useEffect, useState } from 'react'

export function useScrollDirection() {
  const [visible, setVisible] = useState(true)
  useEffect(() => {
    let previous = window.scrollY
    let ticking = false
    const onScroll = () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(() => {
        const current = window.scrollY
        if (current < 80) setVisible(true)
        else if (Math.abs(current - previous) > 8) setVisible(current < previous)
        previous = current
        ticking = false
      })
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return visible
}
